// Only allows a same-origin relative path, rejecting anything that would leave the site.
// Takes `unknown` on purpose: the redirect target comes from the URL via a host-supplied
// `navigationHandler.query()`, and a host that hands over a non-string (a repeated `?from=` query
// param arrives as an array) must be turned away here rather than crash on `startsWith`.
export function internalPath(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return undefined;
  }
  return value;
}
